import DefaultImage from '../../../../../../assets/image/newShop/defaultImg.png';
import CustomCheckbox from '../../../../../../components/mazraeKit/customCheckbox';
import {discountedAdvertisementPrice} from '../helper/discountedAdvertisementPrice';

const AdvertisementBulkSelectableCard = ({
  storeAd,
  isSelected,
  onToggle,
}: {
  storeAd: IGetMyStoreAdsData;
  isSelected: boolean;
  onToggle: (id: string, ad_price: number) => void;
}) => {
  const imageSrc =
    storeAd?.main_image?.image ??
    storeAd?.main_image?.image_128 ??
    storeAd?.sub_brand_main_image?.image ??
    DefaultImage;

  const adPrice = storeAd?.ad_price ?? 0;
  const discountAmount = storeAd?.discount_amount;

  const trueAdPrice = discountedAdvertisementPrice(adPrice, discountAmount);

  return (
    <div
      className={`
         border-[1px] shadow-sm rounded-lg   px-[1rem] py-[1rem] gap-3 flex items-start justify-start  text-md
        cursor-pointer transition-all duration-200
      `}
      onClick={() => {
        if (trueAdPrice) {
          onToggle(storeAd.id, trueAdPrice);
        }
      }}
    >
      {/* Checkbox in top right */}
      <CustomCheckbox
        type="checkbox"
        checked={isSelected}
        onChange={e => {
          e.stopPropagation();
          if (trueAdPrice) {
            onToggle(storeAd.id, trueAdPrice);
          }
        }}
        className="items-end size-4 justify-self-end"
      />

      <div className="flex gap-4">
        <img
          src={imageSrc}
          alt="عکس آگهی"
          className="flex items-center justify-center object-cover rounded-lg size-11"
        />
        <div className="flex flex-col w-full ml-2 space-y-2 ">
          <span className="font-medium text-neutral-900">{storeAd?.title}</span>

          <div className="flex items-center justify-between gap-2">
            <span className="text-gray-600">قیمت</span>
            <span className="font-medium text-zinc-500">
              {trueAdPrice?.toLocaleString() + ' تومان '}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementBulkSelectableCard;
